import { TextField } from "@mui/material"
import Phone from "../../Inputs/Phone"
import Password from "../../Inputs/Password"
import { txt } from "../../../services/translation"
import frenchCountries from "../../../config/frenchCountries"

export default function General({user, onChange, errors, show, edit, hidePhoneCountry}){

    return show && <>
        <TextField
            label={txt('lastName')}
            value={user.lastName || ''}
            onChange={e => onChange({...user, lastName: e.target.value})}
            required
            inputProps={{minLength: 2, maxLength: 200}}
            size='small'
        />

        <TextField
            label={txt('firstName')}
            value={user.firstName || ''}
            onChange={e => onChange({...user, firstName: e.target.value})}
            required
            inputProps={{minLength: 2, maxLength: 200}}
            size='small'
        />

        <TextField
            label={txt('email')}
            type='email'
            value={user.email || ''}
            onChange={e => onChange({...user, 
                email: e.target.value,
                emailVerified: false
            })}
            required
            inputProps={{maxLength: 100, autoComplete: 'off'}}
            size='small'
            error={errors.email ? true : false}
            helperText={errors.email || txt('emailRequirements')}
        />

        <Phone
            value={user.phone || ''}
            onChange={(phone, country) => onChange({...user, 
                phone, 
                country,
                status: frenchCountries.includes(country) ? user.status : {id: 'etranger'}
            })}
            country={user.country}
            required
            error={errors.phone}
            hideCountry={hidePhoneCountry}
        />

        {!edit &&
            <Password 
                value={user.password || ''}
                onChange={e => onChange({...user, password: e.target.value})}
                required
                error={errors.password}
                helperText={txt('passwordRequirements')}
            />
        }
    </>

}